import { passwordConstants } from "../_constants";

export function password(
  state = { fetchingDetail: false, detail: {} },
  action
) {
  switch (action.type) {
    case passwordConstants.RECOVERY_EMAIL_SUBMIT_REQUEST:
      return {
        ...state,
        fetchingDetail: true
      };
    case passwordConstants.RECOVERY_EMAIL_SUBMIT_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail,
        email: action.email
      };
    case passwordConstants.RECOVERY_EMAIL_SUBMIT_FAILURE:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail
      };

    case passwordConstants.SET_PASSWORD_SUBMIT_REQUEST:
      return {
        ...state
      };
    case passwordConstants.SET_PASSWORD_SUBMIT_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail
      };
    case passwordConstants.SET_PASSWORD_SUBMIT_FAILURE:
      return {
        ...state
      };
    case passwordConstants.SET_PASSWORD_WITH_TOKEN_SUBMIT_REQUEST:
      return {
        ...state,
        fetchingDetail: true
      };
    case passwordConstants.SET_PASSWORD_WITH_TOKEN_SUBMIT_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail
      };
    case passwordConstants.SET_PASSWORD_WITH_TOKEN_SUBMIT_FAILURE:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail
      };
    default:
      return state;
  }
}
